import Team from 'records/Team';
import {apiV2, coachingApi} from './api';
import {List, Map} from 'immutable';
import {DepartmentId} from 'records/Department';
import {TeamId} from 'records/TeamId';

const teamUrl = id => `/admin/team/${id}`;

function teamToJson(team) {
  const json = {
    ...team.toJS(),
    // Api is expecting manager id in nested subproperty :(
    manager: {
      id: team.managerId,
    },
  };
  delete json.managerId;
  return json;
}

function jsonToTeam(team) {
  const managerId = team.manager && team.manager.id;
  return new Team({managerId, ...team});
}

export default {
  create(team) {
    return apiV2.postJson(`/admin/team`, teamToJson(team)).then(team => jsonToTeam(team));
  },
  update(team) {
    return apiV2.putJson(teamUrl(team.id), teamToJson(team)).then(team => jsonToTeam(team));
  },
  fetch(teamId) {
    return apiV2.getJson(teamUrl(teamId)).then(team => jsonToTeam(team));
  },
  fetchTeamsForUser(): Promise<List<Team>> {
    const url = '/teams_within_user_perms';
    return apiV2.getJson(url).then(
      ({teams}) => {
        return List(teams.map(team => jsonToTeam(team)));
      },
      error => {
        throw url;
      }
    );
  },
  fetchTeamsForDepartment(departmentId): Promise<[DepartmentId, List<Team>]> {
    const url = `/admin/departments/${departmentId}/teams`;
    return apiV2.getJson(url).then(
      ({teams}) => {
        return [departmentId, List(teams.map(team => jsonToTeam(team)))];
      },
      error => {
        throw departmentId;
      }
    );
  },
  fetchAllTeamsForAdmin(): Promise<List<Team>> {
    return coachingApi.getJson('/teams').then(teams => List(teams.map(t => new Team(t))));
  },
  fetchTeamDepartments(): Promise<Map<TeamId, DepartmentId>> {
    return coachingApi
      .getJson<Record<TeamId, DepartmentId>>('/teams/departments')
      .then(res => Map(res));
  },
  delete(teamId): Promise<void> {
    return apiV2.delete(teamUrl(teamId));
  },
};
